import React from "react";
import HeaderSection from "../../common/HeaderSection/Header";
import galleryimg1 from "../../assets/gallery.png";
import galleryimg2 from "../../assets/Gallery/galleryimg1.jpg";
import galleryimg3 from "../../assets/Gallery/galleryimg2.jpg";
import Quote from "../../common/Quote/Quote";
import poster from "../../assets/poster.png";
import image1 from "../../assets/first-img.png";
import image2 from "../../assets/sec-img.png";
import image3 from "../../assets/Gallery/galleryImg.jpg";
import poster2 from "../../assets/poster2.png";
import poster3 from "../../assets/poster3.png";
import DonateToFood from "../../common/DonateToFood/DonateFood";
import poverty from "../../assets/poverty.png";
import Donate from "../../common/Donation/Donate";
import StoriesOfImpact from "../../common/Story/Story";
import ContactForm from "../../common/ContactForm/Contact";
import "./Gallery.css";
import CarouselPage from "../../common/Carousel/CarouselPage";


function Gallery() {
  const carouselImages = [
    { src: galleryimg1, alt: "First image ",style: { height: "600px", width: "100%", objectFit: "cover" } },
    { src: galleryimg2, alt: "Second image",style: { height: "600px", width: "100%", objectFit: "cover" } },
    { src: galleryimg3, alt: "Third image" ,style: { height: "600px", width: "100%", objectFit: "cover" }},
  ];
  return (
    <>
    <CarouselPage images={carouselImages} />
      <HeaderSection image={galleryimg1}
            imageStyle={{marginTop: "3rem"}} />
      <div className="image">
        <div className="first-image">
          <img src={image1} alt="image1 " />
        </div>
        <div className="second-image">
          <h2>“ Turn tears to smile “</h2>
          <img src={image2} alt="image2" />
        </div>
        <div className="third-image">
          <img src={image3} alt="image3" />
        </div>
      </div>
      <Quote
        text="“ It’s not that what you look at that matters
it’s what you see ”"
      />
      <div className="poster">
        <h1>Gallery</h1>
        <img src={poster} alt="poster" />
      </div>
      <div className="second-poster">
        <img className="poster2" src={poster2} alt="poster2 " />

        <img className="poster3" src={poster3} alt="poster3" />
      </div>
      <DonateToFood />
      {/* <div className="poverty">
        <h1>A life in Extreme Poverty</h1>
        <img src={poverty} alt="Poverty video" />
      </div> */}
      <Donate text="Bring faith in every soul you see" />
      <StoriesOfImpact />
      <ContactForm />
    </>
  );
}

export default Gallery;
